import React, { useState, useEffect } from 'react';
import { Users, UserPlus, 
  Scale, FileText,  Award, 
  Shield, Clock, CheckCircle, Phone, Mail, 
  MapPin, Send, ArrowRight, Home, BookOpen,
  Building, Gavel, Briefcase, Target,
  Zap, Star, TrendingUp, Globe, Lock, Coins
} from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CommercialCases = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const whatsappUrl = "https://wa.me/966115115945";

  const serviceCards = [
    {
      icon: Scale,
      title: "خدمات المصالحة والتقاضي",
      description: "حل النزاعات التجارية عبر الوسائل البديلة وحماية حقوقك القانونية",
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      icon: WhatsAppIcon,
      title: "خدمات الاستشارات القانونية",
      description: "استشارات متخصصة في جميع جوانب القانون التجاري والشركات",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      icon: FileText,
      title: "خدمات صياغة العقود",
      description: "صياغة ومراجعة العقود التجارية والاتفاقيات باحترافية عالية",
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    }
  ];

  const allServices = [
    {
      title: "القضايا المدنية",
      description: "حل النزاعات المدنية والمنازعات العقارية والمطالبات المالية",
      icon: Gavel,
      image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "التقاضي الإداري",
      description: "الترافع أمام المحاكم الإدارية واللجان التأديبية",
      icon: Building,
      image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "تسجيل العلامات التجارية",
      description: "حماية العلامات التجارية وبراءات الاختراع والملكية الفكرية",
      icon: Target,
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "تصفية الشركات",
      description: "إجراءات تصفية الشركات وحل النزاعات بين الشركاء",
      icon: Briefcase,
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "خدمات التحكيم",
      description: "حل النزاعات التجارية عبر التحكيم المحلي والدولي",
      icon: UserPlus,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "التوثيق والإفراغ",
      description: "توثيق العقود والاتفاقيات وإفراغ المستندات القانونية",
      icon: FileText,
      image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "تأسيس الشركات",
      description: "تأسيس الشركات بجميع أنواعها وإعداد الوثائق القانونية",
      icon: Building,
      image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "القضايا الجزائية",
      description: "الدفاع في القضايا الجزائية والجنح والمخالفات",
      icon: Shield,
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "المنازعات العقارية",
      description: "حل النزاعات العقارية والمنازعات على الأراضي والمباني",
      icon: Home,
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "خدمات الاستثمار الأجنبي",
      description: "تسهيل إجراءات الاستثمار الأجنبي والشركات الأجنبية",
      icon: Globe,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "تسوية النزاعات",
      description: "حل النزاعات التجارية عبر الوسائل البديلة للتقاضي",
      icon: UserPlus,
      image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      title: "خدمات الأحوال الشخصية",
      description: "القضايا العائلية والطلاق والميراث والوصية",
      icon: UserPlus,
      image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    }
  ];

  const features = [
    "تقديم الدعم القانوني لتسوية الخلافات عن طريق الصلح",
    "التمثيل والترافع أمام منظومة المحاكم واللجان العدلية",
    "صياغة المذكرات القانونية واللوائح الاعتراضية",
    "إدارة الملفات التجارية بكفاءة عالية",
    "حماية حقوق العملاء في النزاعات التجارية",
    "متابعة الإجراءات القانونية حتى النهاية"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3a23]/10 via-white to-[#0a3a23]/5" dir="rtl">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#0a3a23] via-[#0a3a23] to-[#0a3a23] py-12 sm:py-24 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center text-white">
          <div className="mb-4 sm:mb-8">
            <span className="text-white text-lg sm:text-xl">خدمات قانونية متخصصة</span>
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
            <span className="text-white">خدمات القضايا التجارية</span>
            <div className="w-20 sm:w-32 h-1 bg-[#0a3a23] mx-auto mt-2 sm:mt-4"></div>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl opacity-90 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed mb-4 sm:mb-8 px-4">
            حلول قانونية شاملة لحماية مصالحك التجارية وحل النزاعات باحترافية عالية
          </p>
          <p className="text-sm sm:text-base md:text-lg opacity-80 max-w-xl sm:max-w-2xl mx-auto px-4">
            نقدم خدمات قانونية متخصصة في جميع جوانب القانون التجاري والشركات
          </p>
        </div>

        {/* Navigation Breadcrumb */}
        <div className="absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 flex items-center gap-1 sm:gap-2 text-white text-xs sm:text-sm">
          <Link to="/" className="flex items-center gap-1 hover:text-white/70 transition-colors">
            <Home className="w-3 h-3 sm:w-4 sm:h-4" />
            <span>الرئيسية</span>
          </Link>
          <span>/</span>
          <div className="flex items-center gap-1">
            <BookOpen className="w-3 h-3 sm:w-4 sm:h-4" />
            <span>خدمات القضايا التجارية</span>
          </div>
        </div>
      </div>

      {/* Service Cards Section */}
      <div id="services" className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            خدماتنا المتخصصة
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto px-4">
            نقدم مجموعة شاملة من الخدمات القانونية لحماية مصالحك التجارية
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16 justify-items-center">
          {serviceCards.map((service, index) => (
            <div
              key={index}
              className="group perspective-1000 cursor-pointer w-full max-w-sm"
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className={`relative w-full h-64 sm:h-80 transition-transform duration-700 transform-style-preserve-3d ${
                hoveredCard === index ? 'rotate-y-180' : ''
              }`}>
                {/* Front Side */}
                <div className="absolute inset-0 bg-[#0a3a23] rounded-xl sm:rounded-2xl p-6 sm:p-8 text-white text-center backface-hidden">
                  <service.icon className="w-12 h-12 sm:w-16 sm:h-16 text-white mx-auto mb-4 sm:mb-6" />
                  <h3 className="text-lg sm:text-xl font-bold mb-2 sm:mb-3">{service.title}</h3>
                  <p className="text-sm sm:text-base text-white/90 leading-relaxed">{service.description}</p>
                </div>

                {/* Back Side */}
                <div className="absolute inset-0 bg-[#0a3a23] rounded-xl sm:rounded-2xl p-6 sm:p-8 text-white text-center backface-hidden rotate-y-180">
                  <div className="space-y-3 sm:space-y-4 mb-4 sm:mb-6">
                    <div className="flex items-start gap-2 sm:gap-3">
                      <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                      <span className="text-xs sm:text-sm">تقديم الدعم القانوني لتسوية الخلافات</span>
                    </div>
                    <div className="flex items-start gap-2 sm:gap-3">
                      <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                      <span className="text-xs sm:text-sm">التمثيل والترافع أمام المحاكم</span>
                    </div>
                    <div className="flex items-start gap-2 sm:gap-3">
                      <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                      <span className="text-xs sm:text-sm">صياغة المذكرات القانونية</span>
                    </div>
                  </div>
                  
                  <a
                    href={`${whatsappUrl}?text=أريد الاستفسار عن ${service.title}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-white text-[#0a3a23] px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-bold text-xs sm:text-sm hover:bg-[#0a3a23]/10 transition-colors"
                  >
                    <WhatsAppIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                    تواصل معنا
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* All Services Grid */}
        <div className="mb-12 sm:mb-16">
          <div className="text-center mb-8 sm:mb-12">
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              جميع خدماتنا القانونية
            </h3>
            <p className="text-base sm:text-lg text-gray-600 max-w-xl sm:max-w-2xl mx-auto px-4">
              اكتشف مجموعة شاملة من الخدمات القانونية المتخصصة
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {allServices.map((service, index) => (
              <div key={index} className="bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
                <div className="relative h-40 sm:h-48 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-3 sm:bottom-4 right-3 sm:right-4">
                    <service.icon className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
                  </div>
                </div>
                
                <div className="p-4 sm:p-6">
                  <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-[#0a3a23] transition-colors">
                    {service.title}
                  </h4>
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-3 sm:mb-4">
                    {service.description}
                  </p>
                  
                  <a
                    href={`${whatsappUrl}?text=أريد الاستفسار عن ${service.title}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#0a3a23] hover:text-[#0a3a23]/90 font-semibold transition-colors text-sm sm:text-base"
                  >
                    <span>احصل على الخدمة</span>
                    <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="text-center mb-12 sm:mb-16">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
            خدماتنا المتخصصة
          </h3>
          <div className="flex flex-col sm:flex-wrap justify-center gap-3 sm:gap-4">
            <Link 
              to="/legal-consultation"
              className="inline-flex items-center gap-2 bg-[#0a3a23] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              <WhatsAppIcon className="w-3 h-3 sm:w-4 sm:h-4" />
              الاستشارات القانونية
            </Link>
            <Link 
              to="/judicial-representation"
              className="inline-flex items-center gap-2 bg-[#0a3a23] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              <Gavel className="w-3 h-3 sm:w-4 sm:h-4" />
              التمثيل القضائي والتقاضي
            </Link>

            <a
              href={`${whatsappUrl}?text=أريد الاستفسار عن جميع الخدمات`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white border-2 border-[#0a3a23] text-[#0a3a23] px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold hover:bg-[#0a3a23]/10 transition-colors text-sm sm:text-base"
            >
              <WhatsAppIcon className="w-3 h-3 sm:w-4 sm:h-4" />
              تواصل معنا
            </a>
          </div>
        </div>

        {/* Detailed Features */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 mb-16">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              مميزات خدمات القضايا التجارية
            </h3>
            <p className="text-lg text-gray-600">
              نتميز بخبرة واسعة في مجال القانون التجاري
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start gap-4 p-4 rounded-xl bg-[#0a3a23]/10 hover:bg-[#0a3a23]/20 transition-colors">
                <CheckCircle className="w-6 h-6 text-[#0a3a23] mt-1 flex-shrink-0" />
                <p className="text-gray-700 leading-relaxed">{feature}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="bg-gradient-to-br from-[#0a3a23] to-[#0a3a23] py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center text-white mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              لماذا تختار مكتب أنس للمحاماة؟
            </h2>
            <p className="text-xl opacity-90 max-w-3xl mx-auto">
              نتميز بخبرة واسعة وخدمة متميزة في مجال القانون التجاري
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center text-white">
              <div className="w-16 h-16 bg-[#0a3a23] rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="w-8 h-8 text-black" />
              </div>
              <h3 className="text-xl font-bold mb-2">خبرة واسعة</h3>
              <p className="text-white">أكثر من 15 عاماً من الخبرة في القانون التجاري</p>
            </div>

            <div className="text-center text-white">
              <div className="w-16 h-16 bg-[#0a3a23] rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-black" />
              </div>
              <h3 className="text-xl font-bold mb-2">فريق متخصص</h3>
              <p className="text-white">فريق من المحامين المتخصصين في القانون التجاري</p>
            </div>

            <div className="text-center text-white">
              <div className="w-16 h-16 bg-[#0a3a23] rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="w-8 h-8 text-black" />
              </div>
              <h3 className="text-xl font-bold mb-2">خدمة سريعة</h3>
              <p className="text-white">حل سريع وفعال للنزاعات التجارية</p>
            </div>

            <div className="text-center text-white">
              <div className="w-16 h-16 bg-[#0a3a23] rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-black" />
              </div>
              <h3 className="text-xl font-bold mb-2">حماية حقوقك</h3>
              <p className="text-white">حماية شاملة لحقوقك ومصالحك التجارية</p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact CTA */}
      <div className="py-16">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            احصل على دعم القضايا التجارية
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            تواصل معنا الآن للحصول على دعم القضايا التجارية
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`${whatsappUrl}?text=أريد دعم القضايا التجارية`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#0a3a23] text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-[#0a3a23]/90 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <WhatsAppIcon className="w-6 h-6" />
              تواصل عبر الواتساب
            </a>
            <Link
              to="/Contact"
              className="inline-flex items-center gap-3 bg-gray-800 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-gray-900 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <Send className="w-6 h-6" />
              تواصل معنا
            </Link>
          </div>
        </div>
      </div>

      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href={`${whatsappUrl}?text=أريد دعم القضايا التجارية`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default CommercialCases; 
